/**
 * LandingHeroShell - Suspense fallback for the lazy-loaded Landing page.
 *
 * Previously reproduced the pre-boot HTML hero to keep FCP fast, but that
 * required byte-perfect visual parity with Landing.js. Since Landing's
 * hero (nav layout, font-size ladder, pink-highlight padding, Log-in
 * visibility, etc.) keeps evolving, the shell could never stay in sync,
 * causing a visible two-paint jump on load.
 *
 * Trade-off chosen: render `null` here (blank canvas below the nav bar
 * that Router mounts around us). FCP takes a small hit; LCP stays good
 * because Landing.js is still lazy-split off the main bundle. No visual
 * jump, ever.
 */
const LandingHeroShell = () => null;

export default LandingHeroShell;
